import { useState } from 'react'
import { Autocomplete as AutocompleteComp } from '../../autocomplete' 
import { useSearchEngineStore } from '../../../stores/searchStore'
import { GoogleMapsStructuredPlace } from '../../autocomplete/interfaces/googleMapsInterfaces'

export const AddressAutoComplete = (): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false)
  const { setLocation } = useSearchEngineStore()

  return (
    <div className="flex flex-col gap-y-3">
      <span className="text-normal font-semibold text-[#222]">
        ¿Dónde?
      </span>
      <AutocompleteComp 
        onChange={(a: GoogleMapsStructuredPlace | undefined) => setLocation(a)}
        alignIcon="left"
        iconClassName="!text-primary w-6 h-6"
        placeholder="Colonia, dirección o lugar"
        valueClassName="text-body-l pl-2 !text-primary font-['Red Hat Display']"
        resultContainerClassName="z-[1]"
        fieldClassName={`
          border border-[#CBD3E0] !rounded-lg !py-3 !px-4 !h-[52px]
          ${isFocused ? 'border-2 border-[#222]' : 'border border-[#CBD3E0]'}
        `}
        defaultFieldValue={''}
        iconCleanSearch="!text-primary"
        enableMyLocation={true}
        showPlaceHolderAsPlaceHolder={true}
        placeholderClassName="text-base font-normal outline-none text-[#898CA8]"
        onFocus={(val: boolean) => setIsFocused(val)}
      />
    </div>
  )
}

